module.exports = __webpack_public_path__ + "img/logo_despacho.d0ccfd5a.png";